module.exports = __webpack_public_path__ + "static/media/homepage_atf_3.e47f506e.png";